import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle, Mail, Calendar, Video } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function CitaConfirmada() {
  const location = useLocation();
  const navigate = useNavigate();
  const citaData = location.state?.cita;

  useEffect(() => {
    // Si no hay datos de cita, redirigir al formulario
    if (!citaData) {
      navigate('/formulario-1');
    }
  }, [citaData, navigate]);

  if (!citaData) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center py-12 px-6">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/kompa-logo.png" alt="Kompa" className="h-16 w-auto mx-auto mb-4" />
        </div>

        {/* Card principal */}
        <Card className="bg-gray-800/50 backdrop-blur-xl border-gray-700">
          <CardContent className="p-8 text-center">
            {/* Icono de éxito */}
            <div className="mb-6">
              <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto">
                <CheckCircle className="w-12 h-12 text-green-500" />
              </div>
            </div>

            {/* Título */}
            <h1 className="text-3xl font-bold text-white mb-3">
              ¡Cita Agendada Exitosamente!
            </h1>
            
            <p className="text-gray-400 text-lg mb-8">
              Tu cita ha sido confirmada y registrada en nuestro sistema
            </p>

            {/* Detalles de la cita */}
            <div className="bg-gray-900/50 rounded-xl p-6 mb-8 text-left">
              <h2 className="text-white font-semibold mb-4 text-center">Detalles de tu Cita</h2>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Calendar className="w-5 h-5 text-yellow-500" />
                  <div>
                    <p className="text-gray-400 text-sm">Fecha y Hora</p>
                    <p className="text-white font-medium">{citaData.fecha} a las {citaData.hora}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Video className="w-5 h-5 text-yellow-500" />
                  <div>
                    <p className="text-gray-400 text-sm">Modalidad</p>
                    <p className="text-white font-medium">Cita Virtual - Google Meet</p>
                  </div>
                </div>

                {citaData.expediente && (
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-yellow-500" />
                    <div>
                      <p className="text-gray-400 text-sm">Expediente</p>
                      <p className="text-white font-medium">{citaData.expediente}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Mensaje de email */}
            <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-5 mb-8">
              <div className="flex items-start gap-3">
                <Mail className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
                <div className="text-left">
                  <p className="text-white font-semibold mb-2">Revisa tu correo electrónico</p>
                  <p className="text-gray-300 text-sm">
                    Te hemos enviado un email de confirmación con todos los detalles de tu cita, 
                    incluyendo el <strong>link de Google Meet</strong> para tu reunión virtual.
                  </p>
                  <p className="text-gray-400 text-xs mt-2">
                    Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam.
                  </p>
                </div>
              </div>
            </div>

            {/* Información adicional */}
            <div className="text-gray-400 text-sm space-y-2 mb-8">
              <p>• Si necesitas reprogramar tu cita, podrás hacerlo desde el email de confirmación</p>
              <p>• Te enviaremos un recordatorio antes de tu cita</p>
              <p>• Duración estimada: 30 minutos</p>
            </div>

            {/* Botón de acción */}
            <Button
              onClick={() => navigate('/formulario-1')}
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
            >
              Volver al Inicio
            </Button>
          </CardContent>
        </Card>

        {/* Mensaje de soporte */}
        <p className="text-center text-gray-500 text-sm mt-6">
          ¿Tienes preguntas? Escríbenos a <a href="mailto:merendienmimeta@kompa.global" className="text-yellow-500 hover:text-yellow-400">merendienmimeta@kompa.global</a>
        </p>
      </div>
    </div>
  );
}
